export default "__VITE_ASSET__DO1CqDND__"